import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Button from "./Button";
import HeaderIcon from "./HeaderIcon";

const HeaderFunctionItem = ({ color, iconType, disabled, display, to, visible, customNavAction }) => {
	const colorText = disabled ? "#989898" : color ? color : "blue";
	const navItemClassName = {
		"c-anchor-nav__item": true,
		["item--" + colorText]: true
	};

	const displayText = <p style={{ 'color': colorText }}>{display}</p>;

	const relativeLink =
		<div>
			{(customNavAction ?
				<div style={{ textAlign: 'right' }}>
					<Button style={{ margin: '0px' }} to={to} onClick={(e) => { e.preventDefault(); customNavAction(); }} disabled={disabled}>
						{displayText}<HeaderIcon type={iconType} color={colorText} />
					</Button>
				</div>
				: <Button style={{ margin: '0px' }} to={to} className="c-button--right" disabled={disabled}>
					{displayText}<HeaderIcon type={iconType} color={colorText} />
				</Button>)}
		</div>;

	return (visible ? <div className={classnames(navItemClassName)}>
		{relativeLink}
	</div> : null);
};

HeaderFunctionItem.propTypes = {
	display: PropTypes.string.isRequired,
	to: PropTypes.string.isRequired,
	color: PropTypes.string,
	iconType: PropTypes.string,
	disabled: PropTypes.bool,
	visible: PropTypes.bool,
	showTooltip: PropTypes.bool,
	showBead: PropTypes.bool,
	customNavAction: PropTypes.func,
	tooltipText: PropTypes.string,
	float: PropTypes.string
};

export default HeaderFunctionItem;
